exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cross-button[data-v-aa292ba6] {\n  z-index: 100;\n}\n\n", ""]);

// exports
